import { FC } from 'react';
import { Box } from '@wix/design-system';
import { Service } from '@common/types';
import ServiceInfo from './ServiceInfo';

type SingleCategoryMobileServicesProps = {
  services: Service[];
};

const SingleCategoryMobileServices: FC<SingleCategoryMobileServicesProps> = ({
  services,
}) => {
  return (
    <div data-hook="mobile-one-category-starting-rates">
      {services.map((service: any) => (
        <Box key={service.id} direction="vertical" gap="18px">
          <ServiceInfo service={service} />
        </Box>
      ))}
    </div>
  );
};

export default SingleCategoryMobileServices;
